import ColorfulTag from './colorful-tag';
export default ColorfulTag;
